export default __webpack_public_path__ + "static/Row 3.1_Cornerstonekidz-b898cdb8a42910d8349056033f2a674c.jpg";